module.exports = __webpack_public_path__ + "static/media/trash.4e46e864.svg";